import ConfettiParticle from './ConfettiParticle';

export default class ConfettiDrop extends Phaser.BitmapData {
  constructor(game, width) {
    super(game, '', Math.floor(game.width), Math.floor(game.height));

    this.angle = 0;
    this.tiltAngle = 0;
    this.maxParticles = 150;
    this.particleColours = ['#f7469b', '#ffa000', '#ffc800', '#cbdc33', '#06a9d2'];

    this.particles = [];
    while (this.particles.length < this.maxParticles) {
      let p = new ConfettiParticle(
        this.game,
        this.particleColours[Math.floor(Math.random() * this.particleColours.length)],
        this.canvas.width,
        this.canvas.height
      );
      this.particles.push(p);
    }

    this.drawConfetti();
  }

  drawConfetti() {
    this.clear();
    let p, tx1, ty1, tx2, ty2;
    for (let i = 0; i < this.particles.length; i++) {
      p = this.particles[i];
      tx1 = p.x + p.tilt + p.r / 4;
      ty1 = p.y;
      tx2 = p.x + p.tilt;
      ty2 = p.y + p.tilt + p.r / 4;
      this.ctx.beginPath();
      this.ctx.lineWidth = p.r / 2;
      this.ctx.strokeStyle = p.colour;
      this.ctx.moveTo(tx1, ty1);
      this.ctx.lineTo(tx2, ty2);
      this.ctx.stroke();
    }
  }

  updateConfetti() {
    let particle;

    this.angle += 0.01;
    this.tiltAngle += 0.01;

    for (let i = 0; i < this.particles.length; i++) {
      particle = this.particles[i];

      this.stepParticle(particle, i);
      if (particle.y > this.game.camera.height + 50) {
        this.repositionParticle(particle);
      }
    }

    this.drawConfetti();
  }

  stepParticle(particle, particleIndex) {
    particle.tiltAngle += particle.tiltAngleIncremental;
    particle.y += (Math.cos(this.angle + particle.d) + 1 + particle.r / 2) / 2;
    particle.x += Math.sin(this.angle);
    particle.tilt = Math.sin(particle.tiltAngle - particleIndex / 3) * 15;
  }

  repositionParticle(particle) {
    particle.x = Math.random() * this.game.width;
    particle.y = -50;
    particle.colour = this.particleColours[Math.floor(Math.random() * this.particleColours.length)];
    particle.r = Math.random() * 20 + 10;
    particle.d = Math.random() * 100 + 10;
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/confetti/ConfettiDrop.js